// ! import all of the widget functions
import gsap from 'gsap'
import Swiper from 'swiper'
// import videojs from 'video.js'

// ------------------------------------------------------------

document.addEventListener('DOMContentLoaded', function() { 

    // ! Call all of the widget scripts here.

// ANIMATIONS
const animateLogo = () => {
    const animatedLogos = document.querySelectorAll('.animated-logo')
    if (animatedLogos === null) return;
    const bodyTag = document.querySelector('body')
    // if(bodyTag.classList.contains('home')) {
    //     bodyTag.style.position = 'fixed'
    // }
    animatedLogos.forEach(animatedLogo => {
        const svgs = animatedLogo.querySelectorAll('.animated-svg')
        svgs.forEach(svg => {
            const timeline = gsap.timeline({
                repeat: -1, 
                delay: 0.5,
            })
            const x = svg.getAttribute('data-target-x')
            const y = svg.getAttribute('data-target-y')
            timeline.to(svg, {
                x: `${x}%`,
                y: `${y}%`,
                ease: "elastic.inOut(2.5, 1)",
                duration: 4,
            })
            .to(svg, {
                x: 0,
                y: 0,
                ease: "elastic.inOut(2.5, 0.75)",
                duration: 3,
                delay: 10,
            })
        })
    })
    // if (bodyTag.classList.contains('home')) {
    //     fadeIn('.home header', 2, 2.5)
    //     fadeIn('.video-section', 2, 1.5, {
    //         onComplete: () => {
    //             bodyTag.style.position = 'relative'
    //         }
    //     })
    // }
}

const fadeInUp = (element, duration = 2, delay = 0, options = {}) => {
    const el = document.querySelector(element)
    if (el === null) return;
    const timeline = gsap.timeline(options)
    timeline.set(el, {
        opacity: 0,
        y: 100
    })
    .to(el, {
        opacity: 1,
        y: 0,
        duration: duration,
        ease: "power3.inOut"
    })
}

const fadeIn = (el, duration = 2, delay = 0, options = {}) => {
    if (el === null) return;
    const timeline = gsap.timeline(options)
    timeline.set(el, {
        opacity: 0,
    })
    .to(el, {
        opacity: 1,
        duration: duration,
        ease: "power3.inOut",
        delay: delay
    })
}

// fadeInUp('.hero .animated-logo', 2, {
//     onComplete: animateLogo()
// })

animateLogo();

// const observer = () => {
//     const sections = document.querySelectorAll('section')
//     const observer = new IntersectionObserver((entries) => {
//         entries.forEach((entry) => {
//             if(entry.intersectionRatio > 0.1) {
//                 entry.target.classList.add('visible')
//                 // fadeIn(entry.target, 2, 2)
//             }
//         })
//     }, {
//         threshold: [0, 0.1, 0.2, 0.3, 0.5, 1],
//     })
//     sections.forEach((section) => {
//         observer.observe(section)
//     })
// }
// observer()

// NAVIGATION
const stickyNavigation = () => {
    const mainNavigation = document.querySelector('.site-header')
    const bodyTag = document.querySelector('body')
    if (mainNavigation === null) return
    window.addEventListener('scroll', (e) => {
        if(window.scrollY > 50) {
            if (!bodyTag.classList.contains('menu-open'))
                mainNavigation.classList.add('scrolled')
        } else {
            if (!bodyTag.classList.contains('menu-open'))
                mainNavigation.classList.remove('scrolled')
        }
    })
}
stickyNavigation()

// Event Listener to globally track scroll position to be used by menu
window.addEventListener('scroll', () => { 
    document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`)
});

// When the menu is open keep the body tag in position
const handleFixedBody = () => {
    let scrollY = document.documentElement.style.getPropertyValue('--scroll-y')
    const bodyTag = document.querySelector('body')
    if (bodyTag.classList.contains('menu-open')) {
        bodyTag.style.position = 'fixed'
        bodyTag.style.top = `-${scrollY}`
    } else {
        scrollY = bodyTag.style.top
        bodyTag.style.position = 'relative'
        bodyTag.style.top = 0
        window.scrollTo(0, parseInt(scrollY || '0') * -1)
    }
}

// Toggle the open menu class
const toggleMenu = () => {
    const menuBtn = document.querySelector('.menu-btn')
    const hamburger = menuBtn.querySelector('.hamburger')
    if(menuBtn === null) return
    const bodyTag = document.querySelector('body')
    menuBtn.addEventListener('click', () => {
        bodyTag.classList.toggle('menu-open')
        hamburger.classList.toggle('is-active')
        handleFixedBody()
    })
}
toggleMenu()

// Lightbox
const lightboxes = () => {
    const lightbox = document.querySelector('.lightbox')
    if(lightbox === null) return
    const lightboxImg = lightbox.querySelector('img')
    const lightboxBg = lightbox.querySelector('.lightbox-bg-overlay')
    const lightboxCaption = lightbox.querySelector('figcaption')
    const triggers = document.querySelectorAll('.lightbox-image')
    lightboxCaption.innerText = '';
    // console.log(triggers)
    if (triggers.length > 0) {
        triggers.forEach(trigger => {
            trigger.addEventListener('click', () => {
                const img = trigger.querySelector('img')
                const src = img.getAttribute('src')
                const cap = img.getAttribute('data-caption')

                lightboxImg.setAttribute('src', src)
                lightboxCaption.innerText = cap
                lightbox.classList.add('open')
            })
        })
    }
    lightboxBg.addEventListener('click', () => {
        lightbox.classList.remove('open')
    })
}
lightboxes()

// Swiper functions
const projectCarousels = () => {
    const swiperTags = document.querySelectorAll('.swiper')
    if(swiperTags === null) return
    swiperTags.forEach(swiperTag => {
        const swiper = new Swiper(swiperTag, {
                direction: 'horizontal',
                slidesPerView: 'auto',
                // loopedSlides: 2,
                speed: 2000,
                parallax: true,
                spaceBetween: 30,
                // loop: true,
                autoplay: {
                    delay: 1,
                    disableOnInteraction: false,
                },
                // centeredSlides: true,
            }
        )
        swiper.init();
    })
}
projectCarousels()

// Styling a video player
// const videoPlayers = () => {
//     const videos = document.querySelectorAll('video-js')
//     if(videos === null) return
//     videos.forEach(video => {
//         videojs(video, {
//             controls: true,
//             autoplay: false,
//             preload: 'auto',
//         })
//     })
// }
// videoPlayers()
    
});
